export const bytesToKB = (bytes: number) =>
  (bytes / KILO_BYTES).toFixed(0) + 'KB';

// File size constants
export const MEGA_BYTES = 1024 * 1024; // MB
const KILO_BYTES = 1024 as const; //KB

const INVALID_FILENAME_CHARS = /[<>:"/\\|?*$]/g;
const MAX_CONTROL_CHAR_CODE = 31;

/**
 * 파일/폴더명 한 segment 에서 OS·zip 호환을 위해 사용할 수 없는 문자를 '_' 로 치환한다.
 *
 * - invalid chars: < > : " / \ | ? * $
 * - control chars: 0x00 ~ 0x1F
 * - 양끝 공백 제거
 *
 * 콜론(:)도 invalid 셋에 포함돼 있어 해상도 키 '1:1' 등을 통과시키면 '1_1' 폴더명이
 * 된다 — 다운로드 zip 의 해상도 폴더/파일명은 모두 이 함수를 단일 진입점으로 사용한다.
 *
 * 결과가 빈 문자열일 수 있으므로, 빈 segment 가 허용되지 않는 경로(zip entry 등)
 * 에서는 호출부에서 `|| fallback` 으로 fallback 을 지정한다.
 */
export const sanitizeFileNameSegment = (segment: string): string => {
  return segment
    .replace(INVALID_FILENAME_CHARS, '_')
    .split('')
    .map((char) => (char.charCodeAt(0) <= MAX_CONTROL_CHAR_CODE ? '_' : char))
    .join('')
    .trim();
};
